module.exports = __webpack_public_path__ + "img/whole-wheat-couscous-pilaf.26e054c6.jpg";